import { toast } from 'sonner';
import { PageHeader } from '../ui/PageHeader';
import { Panel } from '../ui/Panel';
import { TwoFactorSetup } from './TwoFactorSetup';
import type { AdminUser } from '../../core/types/adminRequests';
type Props = {
  user: AdminUser;
  onUserChange: (user: AdminUser) => void;
};

/** /be/beveiliging — 2FA instellen of de herstelcodes vernieuwen. */
export function Security({
  user,
  onUserChange
}: Props) {
  return <>
      <PageHeader title="Beveiliging" description="Inloggen met je wachtwoord én een code uit je telefoon." data-id="element-4016" data-mp="1y0zike0idmr7" />
      <Panel className="max-w-2xl" data-id="element-4017" data-mp="1szk08tpptuci">
        <TwoFactorSetup
      // Opnieuw beginnen als de stand van de server verandert.
      key={String(user.twoFactor.enabled)} user={user} onDone={next => {
        toast.success(user.twoFactor.enabled ? 'Nieuwe herstelcodes bewaard' : 'Tweestapsverificatie staat aan');
        onUserChange(next);
      }} data-id="element-4018" data-mp="1o2209stoepgn" />
      </Panel>
    </>;
}